// extracted by mini-css-extract-plugin
module.exports = {"satisticBox":"supplyStatistic_satisticBox__1Rgwf"};